import apiClient from '@/api/client';

class BasicResource {
    constructor (resourceName) {
        this.resourceName = resourceName;
        this.client = apiClient;
    }

    list (params, options) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}`,
            params: params,
        }, options);
    }

    get (id, options) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${id}`,
        }, options);
    }

    create (data, options) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}`,
            data: data,
        }, options);
    }

    delete (id, options) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${id}`,
        }, options);
    }

    retrieve (id, options) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${id}/retrieve`,
        }, options);
    }

    update (id, data, options) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${id}`,
            data: data,
        }, options);
    }
}

export default BasicResource;

